import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";
import CustomTooltip from "./CustomTooltip";
import { ICalc } from "../../model";

export const CalcSelect = Select.ofType<ICalc>();

export const filterCalcs: ItemPredicate<ICalc> = (query, calc) => {

  return calc.nome.replace(/\./g, "").replace(/\,/g, "").toLowerCase().indexOf(query.replace(/\./g, "").replace(/\,/g, "").toLowerCase()) >= 0;

};

export const returnLabel = (item: ICalc) => {

  let new_label = `${item.nome}`

  return (<div style={{ width: "100%" }}>{new_label}</div>)

}

export const renderCalcs: ItemRenderer<ICalc> = (calc, { handleClick, modifiers }) => {

  if (!modifiers.matchesPredicate) {
    return null;
  }

  return (

    <MenuItem
      active={modifiers.active}
      key={calc._id}
      text={<CustomTooltip text={returnLabel(calc)} />}
      onClick={handleClick}
    />

  );

};
